import React, { Fragment } from "react";
import "./App.scss";
import { AppRouter } from "./AppRouter";
import withClearCache from "./ClearCache";

const MainApp = () => {
  return (
    <Fragment>
      <AppRouter />
    </Fragment>
  );
};

const ClearCacheComponent = withClearCache(MainApp);

const App = () => {
  return <ClearCacheComponent />;
};

export default App;
